import axios from "axios";
import {api} from "@/store/api";
import router from "@/router";

function make_note () {
  return {
    id: undefined,
    type: 'nota',
    createdAt: new Date(),
    dinte: '',
    detalii: '',
    pics: [],
  }
}

export default {
  state: {
    formData: new FormData(),
    note: make_note(),
    remove_note_img: false,
    server_conflict_detalii: null,
    pending_updated_at: null,
    last_error_message: null
  },
  mutations: {
    SET_NOTE (state, data) {
      state.note = { ...data };
    },
    SET_NOTE_FIELD (state, { key, value }) {
      state.note[key] = value;
    },
    RESET_NOTE (state) {
      state.note = make_note();
    },
    REMOVE_NOTE_IMG (state, value) {
      state.remove_note_img = value;
      state.note.pics = [];
      state.formData.delete('remove_img');
    },
    RESET_FORM_DATA (state) {
      state.formData = new FormData();
    },
    UPDATE_NOTE (state, note) {
      state.note = note;
    },
    UPDATE_NOTE_DETALII_BY_ID (state, note) {
      if (state.note.id === note.id) {
        state.note.detalii = note.detalii;
      }
    },
    ADD_IMGS_TO_NOTE (state, { file }) {
      state.formData.delete('img');
      state.formData.append('img', file);
      state.remove_note_img = false;
    },
    SET_NOTE_CONFLICT (state, { detalii, updatedAt }) {
      state.server_conflict_detalii = detalii;
      state.pending_updated_at = updatedAt;
    },
    CLEAR_NOTE_CONFLICT (state) {
      state.server_conflict_detalii = null;
      state.pending_updated_at = null;
    },
    SET_NOTE_ERROR (state, message) {
      state.last_error_message = message;
    },
    CLEAR_NOTE_ERROR (state) {
      state.last_error_message = null;
    },
  },
  actions: {
    async update_note_by_debouncer_sse ({ state, commit }) {
      try {
        const form_data = new FormData();
        form_data.append('id', state.note.id);
        form_data.append('detalii', state.note.detalii);
        const patient_id = router.currentRoute.params.id;
        await axios.post(`${api.handle_note}/${patient_id}`, form_data);
        commit('UPDATE_HISTORY_NOTE_DETALII', state.note);
      } catch (err) {
        console.log(err);
      }
    },
    async handle_note ({state, commit}, { overwrite = false } = {} ) {
      try {
        delete state.note.pics;
        state.remove_note_img && state.formData.append('remove_img', 'yes');
        !state.note.id && delete state.note.id;

        Object.keys(state.note).forEach(key => {
          if (key === 'updatedAt') return;

          const value = state.note[key];

          if (value === null || value === undefined) return;

          state.formData.append(key, value);
        });

        const updatedAt = overwrite
          ? state.pending_updated_at
          : state.note.updatedAt;

        if (updatedAt) {
          state.formData.append('updatedAt', updatedAt);
        }

        const patient_id = router.currentRoute.params.id;
        const { data } = await axios.post(`${api.handle_note}/${patient_id}`, state.formData);
        commit('UPDATE_NOTE', data);
        commit('UPDATE_HISTORY_NOTE', data);
        commit('RESET_FORM_DATA');
        return { ok: true };
      } catch (err) {
        if (err.response?.status === 409) {
          commit('RESET_FORM_DATA');
          const sn = err.response.data.serverNote;
          commit('SET_NOTE_CONFLICT', { detalii: sn.detalii, updatedAt: sn.updatedAt });
          return { ok: false, conflict: true };
        }
        commit('SET_NOTE_ERROR', err.response?.data?.msg || 'Ceva nu a mers. Vă rugăm încercați din nou.');
        const stackParts = [
          err.stack || '',
          `status: ${err.response?.status ?? 'no-response'}`,
          `response: ${err.response ? JSON.stringify(err.response.data) : 'none'}`
        ];
        axios.post(api.log_error, {
          message: err.message || 'Unknown error',
          page: 'NoteEditor',
          stack: stackParts.join('\n')
        }).catch(() => {});
        return { ok: false, conflict: false };
      }
    },
    async delete_note ({ state, commit }) {
      try {
        const patient_id = router.currentRoute.params.id;
        await axios.delete(`${api.delete_note}/${patient_id}/${state.note.id}`);
        commit('RESET_FORM_DATA');
        commit('DELETE_NOTE_FROM_HISTORY', state.note.id);
        commit('TOGGLE_MODAL', false);
      } catch (err) {
        console.log(err)
      }
    }
  },
}
